"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCreator = void 0;
var creatorBase_1 = require("./creatorBase");
var companiesEndpoints_1 = require("./endpoints/companiesEndpoints");
var modulesEndpoints_1 = require("./endpoints/modulesEndpoints");
var processEndpoints_1 = require("./endpoints/processEndpoints");
exports.createCreator = function (options, extension) {
    var base = creatorBase_1.createCreatorBase(options);
    return __assign(__assign(__assign(__assign({ get access_token() {
            return base.accessors.access_token;
        },
        set access_token(val) {
            base.accessors.access_token = val;
        },
        get company_name_key() {
            return base.accessors.company_name_key;
        },
        set company_name_key(val) {
            base.accessors.company_name_key = val;
        },
        get creator_base_url() {
            return base.accessors.creator_base_url;
        },
        set creator_base_url(val) {
            base.accessors.creator_base_url = val;
        },
        get environment() {
            return base.accessors.environment;
        },
        set environment(val) {
            base.accessors.environment = val;
        } }, companiesEndpoints_1.createCompaniesEndpoints(base)), modulesEndpoints_1.createModulesEndpoints(base)), processEndpoints_1.createProcessEndpoints(base)), (extension === null || extension === void 0 ? void 0 : extension(base)));
};
//# sourceMappingURL=creator.js.map